import React, { useContext } from 'react';
import { Label, StyledRadio, StyledBox, StyledText, StyledSubText } from './styles.js';
import { RadioGroupContext } from '../RadioGroup/RadioGroup.js';

const ProductSurveyRadioButton = props => {
  const {
    value,
    subText
  } = props;
  const radioGroupContext = useContext(RadioGroupContext);
  const handleOnChange = e => {
    (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.onChange) && radioGroupContext.onChange(e);
  };
  const name = (radioGroupContext === null || radioGroupContext === void 0 ? void 0 : radioGroupContext.name) || 'productsurveyradio';
  return /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(StyledRadio, {
    type: "radio",
    name: name,
    value: value,
    onChange: handleOnChange
  }), /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement(StyledText, {
    as: "p"
  }, value), subText && /*#__PURE__*/React.createElement(StyledSubText, {
    as: "p"
  }, subText)));
};
ProductSurveyRadioButton.displayName = "ProductSurveyRadioButton";
var ProductSurveyRadioButton$1 = ProductSurveyRadioButton;

export { ProductSurveyRadioButton$1 as default };
